import React from "react";
import Content from "../components/DashboardC/Content";
import CompletarRegistroComponente from "../components/minicomponentes/CompletarRegistroComponente";

export const CompletarRegistro = () => {
  return (
    <>
      <Content />
      <CompletarRegistroComponente />
    </>
  );
};

export default CompletarRegistro;
